module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/default-048fbb0da1f766be0f5651b550f05bc5.png";